export const Dialog = {
    MuiDialogTitle: {
        defaultProps: {
            variant: "h6"
        }
    },
    MuiDialogContentText: {
        defaultProps: {
            variant: "body2"
        }
    },
    MuiDialogContent: {
        styleOverrides: {
            root: ({ theme })=>({
                    padding: theme.spacing(0, 3, 2, 3),
                    ["&:last-child"]: {
                        padding: theme.spacing(0, 3, 3, 3)
                    },
                    ["&:first-child"]: {
                        padding: theme.spacing(2, 3)
                    }
                })
        }
    },
    MuiDialogActions: {
        styleOverrides: {
            root: ({ theme })=>({
                    padding: theme.spacing(1, 3, 2, 3),
                    ["&:first-child"]: {
                        padding: theme.spacing(2, 3)
                    }
                })
        }
    },
    MuiDialog: {
        defaultProps: {
            fullWidth: true
        },
        styleOverrides: {
            paper: ({ theme })=>({
                    borderRadius: Number(theme.shape.borderRadius) * 2
                })
        }
    }
};

//# sourceMappingURL=Dialog.js.map